import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import { API_BASE } from '../config';
import './AnnouncementsPage.css';

const AnnouncementsPage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('Tümü');
  const [categories, setCategories] = useState(['Tümü']);

  useEffect(() => {
    fetch(`${API_BASE}/announcements`)
      .then(res => res.json())
      .then(data => {
        setAnnouncements(data);
        const cats = ['Tümü', ...new Set(data.map(a => a.category).filter(Boolean))];
        setCategories(cats);
      })
      .catch(() => {});
  }, []);

  const filtered = selectedCategory === 'Tümü'
    ? announcements
    : announcements.filter(a => a.category === selectedCategory);

  return (
    <div className="ann-page">
      <section className="ann-page-hero">
        <div className="ann-page-hero-content">
          <span className="ann-page-hero-badge">Haberler & Bilgilendirmeler</span>
          <h1 className="ann-page-hero-title">Duyurular</h1>
          <p className="ann-page-hero-desc">Tüm duyurularımızı buradan takip edebilirsiniz</p>
        </div>
      </section>

      <section className="ann-page-content">
        <div className="ann-page-container">
          <div className="ann-page-filters">
            {categories.map(cat => (
              <button
                key={cat}
                className={`ann-page-filter ${selectedCategory === cat ? 'active' : ''}`}
                onClick={() => setSelectedCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          {filtered.length === 0 ? (
            <div className="ann-page-empty">Bu kategoride duyuru bulunmamaktadır.</div>
          ) : (
            <div className="ann-page-grid">
              {filtered.map(ann => (
                <Link to={`/${ann.slug}`} className="ann-page-card" key={ann._id}>
                  <div className="ann-page-card-image">
                    {ann.image && <img src={ann.image} alt={ann.title} />}
                    <div className="ann-page-card-overlay"></div>
                    {ann.category && <span className="ann-page-card-category">{ann.category}</span>}
                  </div>
                  <div className="ann-page-card-body">
                    {ann.date && (
                      <div className="ann-page-card-date">
                        <FaCalendarAlt />
                        <span>{ann.date}</span>
                      </div>
                    )}
                    <h3 className="ann-page-card-title">{ann.title}</h3>
                    {ann.summary && <p className="ann-page-card-summary">{ann.summary}</p>}
                    <span className="ann-page-card-link">
                      Devamını Oku <FaArrowRight />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default AnnouncementsPage;
